import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Package, Calendar, DollarSign, Hash, MapPin, Wrench } from 'lucide-react';
import { getServiceStatus } from '../../utils/scheduling';

const AssetCard = ({ asset, delay = 0 }) => {
  const getTypeLabel = (type) => {
    const types = {
      appliance: 'Appliance',
      vehicle: 'Vehicle',
      hvac: 'HVAC',
      plumbing: 'Plumbing',
      other: 'Other'
    };
    return types[type] || type;
  };

  const serviceStatus = getServiceStatus(asset.nextServiceDate);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.3 }}
    >
      <Link to={`/asset/${asset.id}`}>
        <div className="glassmorphic-hover p-6 h-full">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <h3 className="text-xl font-medium text-foreground mb-1">{asset.name}</h3>
              <div className="flex items-center space-x-2">
                <p className="text-sm text-muted-foreground">{getTypeLabel(asset.type)}</p>
                {asset.location && (
                  <>
                    <span className="text-muted-foreground">•</span>
                    <div className="flex items-center text-xs text-muted-foreground">
                      <MapPin className="h-3 w-3 mr-1" />
                      <span>{asset.location}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="flex flex-col items-end space-y-1">
              {serviceStatus && (serviceStatus.variant === 'destructive' || serviceStatus.variant === 'warning') && (
                <span className={`px-2 py-1 text-xs rounded-md ${
                  serviceStatus.variant === 'destructive' ? 'bg-destructive/20 text-destructive' : 'bg-primary/20 text-primary'
                }`}>
                  Service {serviceStatus.variant === 'destructive' ? 'Overdue' : 'Due Soon'}
                </span>
              )}
            </div>
          </div>

          <div className="space-y-2">
            {asset.purchaseDate && (
              <div className="flex items-center text-sm text-body">
                <Calendar className="h-4 w-4 mr-2" />
                <span>Purchased {new Date(asset.purchaseDate).toLocaleDateString()}</span>
              </div>
            )}
            
            {asset.cost && (
              <div className="flex items-center text-sm text-body">
                <DollarSign className="h-4 w-4 mr-2" />
                <span>${parseFloat(asset.cost).toFixed(2)}</span>
              </div>
            )}
            
            {asset.serialNumber && (
              <div className="flex items-center text-sm text-body">
                <Hash className="h-4 w-4 mr-2" />
                <span>{asset.serialNumber}</span>
              </div>
            )}
          </div>

          {asset.notes && (
            <p className="mt-4 text-sm text-body line-clamp-2">{asset.notes}</p>
          )}
        </div>
      </Link>
    </motion.div>
  );
};

export default AssetCard;

